import { HardDrive, Home, Folder } from "lucide-react";

export default function DriveSidebar({ rootFolders, currentPath, itemCount, onNavigate }) {
  return (
    <aside className="w-52 bg-[#F8F9FA] border-r border-border flex flex-col flex-shrink-0">
      <div className="px-4 py-3 border-b border-border flex items-center gap-2">
        <HardDrive className="w-4 h-4 text-[#A8A67A]" strokeWidth={1.5} />
        <span className="text-xs font-semibold uppercase tracking-wider">Ellerston Drive</span>
      </div>

      <div className="flex-1 overflow-y-auto py-2">
        <button
          onClick={() => onNavigate("/")}
          className={`w-full flex items-center gap-2 px-4 py-2 text-xs transition-colors ${
            currentPath === "/" ? "bg-[#A8A67A]/10 text-[#A8A67A] font-semibold border-l-2 border-[#A8A67A]" : "text-muted-foreground hover:bg-white hover:text-foreground border-l-2 border-transparent"
          }`}
          data-testid="nav-root"
        >
          <Home className="w-3.5 h-3.5 flex-shrink-0" />
          <span>All Files</span>
        </button>

        {rootFolders.length > 0 && (
          <p className="text-[9px] text-muted-foreground uppercase tracking-widest px-4 pt-3 pb-1">Folders</p>
        )}

        {rootFolders.map(f => (
          <button
            key={f.path}
            onClick={() => onNavigate(f.path)}
            className={`w-full flex items-center gap-2 px-4 py-2 text-xs transition-colors ${
              currentPath === f.path || currentPath.startsWith(f.path + "/")
                ? "bg-[#A8A67A]/10 text-[#A8A67A] font-semibold border-l-2 border-[#A8A67A]"
                : "text-muted-foreground hover:bg-white hover:text-foreground border-l-2 border-transparent"
            }`}
            data-testid={`sidebar-folder-${f.name}`}
          >
            <Folder className="w-3.5 h-3.5 text-amber-500 flex-shrink-0" />
            <span className="truncate">{f.name}</span>
          </button>
        ))}
      </div>

      <div className="px-4 py-3 border-t border-border">
        <p className="text-[10px] text-muted-foreground mb-1">{itemCount} item{itemCount !== 1 ? "s" : ""} in view</p>
        <div className="h-1 bg-border rounded-full overflow-hidden">
          <div className="h-full bg-[#A8A67A] rounded-full" style={{ width: "12%" }} />
        </div>
      </div>
    </aside>
  );
}
